

import VueRouter from 'vue-router';

import NotFound from './NotFound';
import Home from './components/Home/Home';
import PromoterHome from './components/Promoter/PromoterHome';
// import PromoterBase from './components/Promoter/PromoterBase';

// import PromoterDashboard from './components/Promoter/PromoterDashboard';
// import PromoterTerms from './components/Promoter/PromoterTerms';
// import PromoterActivities from './components/Promoter/PromoterActivities';
// import PromoterAddActivity from './components/Promoter/PromoterAddActivity';
// import PromoterActivityImages from './components/Promoter/PromoterActivityImages';
// import PromoterActivitiesCalendar from './components/Promoter/PromoterActivitiesCalendar';
// import PromoterSettings from './components/Promoter/PromoterSettings';
// import PromoterRegister from './components/Promoter/PromoterRegister';
import RegistrationSuccess from './components/User/RegistrationSuccess';
import PromoterRegistrationSuccess from './components/User/PromoterRegistrationSuccess';
import ValidateEmail from './components/User/ValidateEmail';
import Language from './components/Language/Language';
import Login from './components/User/Login';
import RecoverAccount from './components/User/RecoverAccount';
import ResetPassword from './components/User/ResetPassword';
import Activity from './components/Activity/Activity';
import Search from './components/Search/Search';

import AdminDashboard from './components/Admin/AdminDashboard';
import AdminActivities from './components/Admin/AdminActivities';
import AdminUsers from './components/Admin/AdminUsers';
import AdminPayments from './components/Admin/AdminPayments';
import AdminBookings from './components/Admin/AdminBookings';

const PromoterDashboard = r => require.ensure([], () => r(require('./components/Promoter/PromoterDashboard')), 'promoter'); // eslint-disable-line global-require
const PromoterTerms = r => require.ensure([], () => r(require('./components/Promoter/PromoterTerms')), 'promoter'); // eslint-disable-line global-require
const PromoterActivities = r => require.ensure([], () => r(require('./components/Promoter/PromoterActivities')), 'promoter'); // eslint-disable-line global-require
const PromoterAddActivity = r => require.ensure([], () => r(require('./components/Promoter/PromoterAddActivity')), 'promoter'); // eslint-disable-line global-require
const PromoterActivityImages = r => require.ensure([], () => r(require('./components/Promoter/PromoterActivityImages')), 'promoter'); // eslint-disable-line global-require
const PromoterActivitiesCalendar = r => require.ensure([], () => r(require('./components/Promoter/PromoterActivitiesCalendar')), 'promoter'); // eslint-disable-line global-require
const PromoterPayments = r => require.ensure([], () => r(require('./components/Promoter/PromoterPayments')), 'promoter'); // eslint-disable-line global-require
const PromoterSettings = r => require.ensure([], () => r(require('./components/Promoter/PromoterSettings')), 'promoter'); // eslint-disable-line global-require
const UserSettings = r => require.ensure([], () => r(require('./components/User/UserSettings')), 'user'); // eslint-disable-line global-require
const PromoterRegister = r => require.ensure([], () => r(require('./components/Promoter/PromoterRegister')), 'promoter'); // eslint-disable-line global-require
const PromoterBookings = r => require.ensure([], () => r(require('./components/Promoter/PromoterBookings')), 'promoter'); // eslint-disable-line global-require
const PromoterOccurrence = r => require.ensure([], () => r(require('./components/Promoter/PromoterOccurrence')), 'promoter'); // eslint-disable-line global-require
const UserRegister = r => require.ensure([], () => r(require('./components/User/Register')), 'user'); // eslint-disable-line global-require
const Booking = r => require.ensure([], () => r(require('./components/Booking/Booking')), 'user'); // eslint-disable-line global-require
const MyBookings = r => require.ensure([], () => r(require('./components/Booking/MyBookings')), 'user'); // eslint-disable-line global-require
const Voucher = r => require.ensure([], () => r(require('./components/Booking/Voucher')), 'user'); // eslint-disable-line global-require
const Payment = r => require.ensure([], () => r(require('./components/Payment/Payment')), 'user'); // eslint-disable-line global-require
const UserTerms = r => require.ensure([], () => r(require('./components/UserTerms')), 'user'); // eslint-disable-line global-require
const AboutUs = r => require.ensure([], () => r(require('./components/AboutUs')), 'user'); // eslint-disable-line global-require
const Faq = r => require.ensure([], () => r(require('./components/Faq')), 'user'); // eslint-disable-line global-require
const PrivacyPolicy = r => require.ensure([], () => r(require('./components/PrivacyPolicy')), 'user'); // eslint-disable-line global-require

const routes = [
  { path: '/', redirect: '/en' },
  {
    path: '/:lang',
    component: Language,
    children: [
      { path: '', component: Home, meta: { title: 'Suppliers' } },
      { path: 'supplier', component: PromoterHome },
      { path: 'supplier/dashboard', component: PromoterDashboard, name: 'Supplier DashBoard', meta: { title: 'Supplier Dashboard' } },
      { path: 'supplier/terms', component: PromoterTerms, name: 'Suppleer Terms', meta: { title: 'Terms' } },
      { path: 'supplier/activities', component: PromoterActivities, name: 'Suppler Activities', meta: { title: 'Supplier Activities' } },
      { path: 'supplier/activities/create', component: PromoterAddActivity, name: 'Supplier Add Activity', meta: { title: 'Add Activity' } },
      { path: 'supplier/activities/calendar', component: PromoterActivitiesCalendar, name: 'Supplier Calendar', meta: { title: 'Calendar' } },
      { path: 'supplier/activities/:slug', component: PromoterAddActivity, name: 'Supplier Edit Activity', meta: { title: 'Edit Activity' } },
      { path: 'supplier/activities/:slug/images', component: PromoterActivityImages, name: 'Supplier Images', meta: { title: 'Images' } },
      { path: 'supplier/activities/:slug/calendar', component: PromoterActivitiesCalendar, name: 'Supplier Calendar for Activity', meta: { title: 'Calendar' } },
      { path: 'supplier/settings', component: PromoterSettings, name: 'Supplier Settings', meta: { title: 'Supplier Settings' } },
      { path: 'supplier/register', component: PromoterRegister, name: 'SupplierRegistration', meta: { title: 'Supplier Registration' } },
      { path: 'supplier/validateEmail', component: ValidateEmail, name: 'Supplier Email Validation', meta: { title: 'Email Validation' } },
      { path: 'promoter/validateEmail', component: ValidateEmail, name: 'Supplier Email Validation2', meta: { title: 'Email Validation' } },
      { path: 'supplier/bookings', component: PromoterBookings, name: 'Supplier Bookings', meta: { title: 'Bookings' } },
      { path: 'supplier/payments', component: PromoterPayments, name: 'Supplier Payments', meta: { title: 'Payments' } },
      { path: 'supplier/occurrence/:id', component: PromoterOccurrence, name: 'Supplier Booking', meta: { title: 'Booking' } },

      { path: 'user/validateEmail', component: ValidateEmail, name: 'User Email Validation', meta: { title: 'Email Validation' } },
      { path: 'activity/:slug', component: Activity, name: 'User Activity', meta: { title: 'Activity' } },
      { path: 'book/:slug', component: Booking, name: 'User Booking', meta: { title: 'Booking' } },
      { path: 'bookings', component: MyBookings, name: 'User Bookings', meta: { title: 'My Bookings' } },
      { path: 'bookings/:id', component: Voucher, name: 'User Voucher', meta: { title: 'Voucher' } },
      { path: 'registrationSuccess', component: RegistrationSuccess, name: 'User Registration Success', meta: { title: 'Registration Success' } },
      { path: 'promoterRegistrationSuccess', component: PromoterRegistrationSuccess, name: 'Supplier Registration Success', meta: { title: 'Registration Success' } },
      { path: 'recover', component: RecoverAccount, name: 'Account Recovery', meta: { title: 'Account Recovery' } },
      { path: 'resetPassword', component: ResetPassword, name: 'Reset Password', meta: { title: 'Reset Password' } },
      { path: 'login', component: Login, name: 'Login', meta: { title: 'Login' } },
      { path: 'register', component: UserRegister, name: 'User Register', meta: { title: 'Register' } },
      { path: 'search', component: Search, name: 'User Search', meta: { title: 'Search' } },
      { path: 'user/settings', component: UserSettings, name: 'User Settings', meta: { title: 'User Settings' } },
      { path: 'payment', component: Payment, name: 'User Payment', meta: { title: 'Payment' } },
      { path: 'terms', component: UserTerms, name: 'Terms of Use', meta: { title: 'Terms of Use' } },
      { path: 'about-us', component: AboutUs, name: 'About Us', meta: { title: 'About Us' } },
      { path: 'faq', component: Faq, name: 'FAQ', meta: { title: 'Frequently Asked Questions' } },
      { path: 'privacy-policy', component: PrivacyPolicy, name: 'Privacy Policy', meta: { title: 'Privacy Policy' } },

      // admin
      { path: 'admin/dashboard', component: AdminDashboard, name: 'Admin Dashboard', meta: { title: 'Admin Dashboard' } },
      { path: 'admin/activities', component: AdminActivities, name: 'Admin Activities', meta: { title: 'Admin Activities' } },
      { path: 'admin/users', component: AdminUsers, name: 'Admin Users', meta: { title: 'admin users' } },
      { path: 'admin/payments', component: AdminPayments, name: 'Admin Payments', meta: { title: 'admin payments' } },
      { path: 'admin/bookings', component: AdminBookings, name: 'Admin Bookings', meta: { title: 'admin bookings' } },
    ],
  },
  { path: '*', component: NotFound, name: 'Page Not Found', meta: { title: 'Page Not Found' } },
];
const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

router.afterEach((to, from) => {
  if (typeof window.vue !== 'undefined') {
    if (
      from.path !== '/pt/user/validateEmail' &&
      from.path !== '/en/user/validateEmail' &&
      from.path !== '/en/login' &&
      from.path !== '/pt/login'
    ) {
      window.vue.$store.dispatch('setPreviousUrl', from.fullPath);
    }
  }

  let title = to.meta.title;
  if (typeof window.vue !== 'undefined') {
    if (typeof window.vue.t !== 'undefined') {
      setTimeout(() => {
        title = window.vue.t(to.meta.title);
        document.title = `Booknatura – ${title}`;
      }, 0);
    }
  }
  document.title = `Booknatura – ${title}`;
  if (typeof _paq !== 'undefined') {
    if (window.vue !== undefined) {
      if (window.vue.$store.state.user.data.username !== '') {
        window._paq.push(['setUserId', window.vue.$store.state.user.data.username]); // eslint-disable-line
      }
    }
    window._paq.push(['setCustomUrl', window.location.pathname]); // eslint-disable-line
    window._paq.push(['setDocumentTitle', document.title]); // eslint-disable-line
    window._paq.push(['trackPageView']); // eslint-disable-line
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/routes.js